import LoadingSpinner from "@/components/LoadingSpinner"
import FolderCard from "@/features/shared/components/FolderCard"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { handleDate } from "../../../utils/Functions"
import { useGetHealthPlan } from "../hooks/useGetHealthPlan"

const HealthPlanHistory = () => {
    const { healthPlans, isLoading, refetch } = useGetHealthPlan()
    const navigate = useNavigate()

    const startPolling = () => {
        const intervalId = setInterval(() => {
            refetch();
        }, 60000);

        return intervalId;
    };

    const stopPolling = (intervalId: NodeJS.Timeout) => {
        clearInterval(intervalId);
    };

    useEffect(() => {
        const intervalId = startPolling();
        return () => {
            stopPolling(intervalId);
        };
    }, [healthPlans, refetch]);

    if (isLoading) {
        return (
            <LoadingSpinner />
        )
    }

    return (
        <div className="w-full h-full flex flex-col space-y-sm max-w-[1068px]">
            {
                healthPlans && healthPlans.map((plan, index) => {
                    if (index !== 0) {
                        const currentDate = handleDate(plan.created_at, "dd.MM.yyyy");
                        const prevDate = handleDate(healthPlans[index - 1].created_at, "dd.MM.yyyy");
                        const spanDate = `${currentDate} <> ${prevDate}`

                        return (
                            <FolderCard
                                onClick={() => navigate(`/old-health-plan?id=${plan.id}&span-date=${spanDate}`)}
                                title={spanDate}
                                isTitle={false}
                            />
                        );
                    }
                })
            }
        </div>
    )
}

export default HealthPlanHistory
